export const appCdnURL = "https://skole.aschehoug.no/static/"

export const appHead = {"link":[{"rel":"icon","type":"image/x-icon","href":"/static/favicon.png"}],"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"name":"theme-color","content":"#00423E"},{"property":"og:type","content":"website"}],"style":[],"script":[{"innerHTML":"(function integrateHubspotConsentWithCookieYes() {\n  window.disableHubSpotCookieBanner = true;\n\n  document.addEventListener('cookieyes_banner_load', ({ detail }) => {\n    if (!detail || !detail.categories) {\n      return;\n    }\n    window._hsp ||= [];\n    window._hsp.push(['setHubSpotConsent', {\n      analytics: !!detail.categories.analytics,\n      advertisement: !!detail.categories.advertisement,\n      functionality: !!detail.categories.functional\n    }]);\n  });\n\n  document.addEventListener('cookieyes_consent_update', ({ detail }) => {\n    if (!detail || !detail.accepted) {\n      return;\n    }\n    const acceptedCategories = new Set(detail.accepted);\n    window._hsp ||= [];\n    window._hsp.push(['setHubSpotConsent', {\n      analytics: acceptedCategories.has('analytics'),\n      advertisement: acceptedCategories.has('advertisement'),\n      functionality: acceptedCategories.has('functional')\n    }]);\n  });\n})()","type":"text/javascript","id":"hs-cy-integration"},{"key":"vipps-button","src":"https://checkout.vipps.no/checkout-button/v1/vipps-checkout-button.js","type":"text/javascript","async":true}],"noscript":[],"htmlAttrs":{}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = {"enabled":false}

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt","class":"isolate"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = false

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const useStateDefaults = {"resetOnClear":true}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true

export const granularCachedData = true

export const pendingWhenIdle = false

export const alwaysRunFetchOnKeyChange = false

export const asyncCallHook = true